'use client';

import { YMUtils } from '@actr/logger/src/utils/ym';
import { canUseDom } from '@actr/utilities/src/dom';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import ym from 'react-yandex-metrika';

import config from '@/configs';

const YandexMetrika = () => {
  const pathname = usePathname();
  const interval = useRef<ReturnType<typeof setInterval> | undefined>(undefined);
  const [isYMReady, setIsYMReady] = useState(false);
  const counterName = `yaCounter${config.YM_TrackingID}`;

  useEffect(() => {
    startObservation();
    if (canUseDom && isYMReady) {
      ym('getClientID', (clientID: string) => {
        YMUtils.setClientId(clientID);
      });
    }
  }, [canUseDom, isYMReady]);

  useEffect(() => {
    if (canUseDom && isYMReady) {
      ym('hit', pathname);
    }
  }, [pathname]);

  const startObservation = () => {
    let tries = 0;
    interval.current = setInterval(() => {
      // @ts-expect-error @ts-ignore
      setIsYMReady(Boolean(window[counterName]));
      tries++;
      if (isYMReady || tries > 10) {
        clearInterval(interval.current);
      }
    }, 500);
  };

  return null;
};

export default YandexMetrika;
